/**
 * @generated SignedSource<<83513963a330b44fc9dce914293409a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrgWorkspaceAdminMutation$variables = {
  name?: string | null;
  parentWorkspaceId?: string | null;
  workspaceId: string;
};
export type OrgWorkspaceAdminMutation$data = {
  readonly workspace: {
    readonly update: {
      readonly id: string;
      readonly name: string;
      readonly parentId: string | null;
    };
  };
};
export type OrgWorkspaceAdminMutation = {
  response: OrgWorkspaceAdminMutation$data;
  variables: OrgWorkspaceAdminMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parentWorkspaceId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "workspaceId"
      }
    ],
    "concreteType": "WorkspaceMutation",
    "kind": "LinkedField",
    "name": "workspace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "setName",
            "variableName": "name"
          },
          {
            "kind": "Variable",
            "name": "setParentWorkspaceId",
            "variableName": "parentWorkspaceId"
          }
        ],
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "update",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "parentId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgWorkspaceAdminMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "OrgWorkspaceAdminMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "10062306e5de5313c2b92182210b5a6f",
    "id": null,
    "metadata": {},
    "name": "OrgWorkspaceAdminMutation",
    "operationKind": "mutation",
    "text": "mutation OrgWorkspaceAdminMutation(\n  $workspaceId: ID!\n  $name: String\n  $parentWorkspaceId: ID\n) {\n  workspace(id: $workspaceId) {\n    update(setName: $name, setParentWorkspaceId: $parentWorkspaceId) {\n      id\n      name\n      parentId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "50b4d4b976b252fdfe5d9ff3263e6685";

export default node;
